import { ReactElement } from 'react'
import FormCollapsibleSection from './FormCollapsibleSection'
import { CollapsibleBoxSectionProps } from './collapsibleSectionProps'
import { FormSectionIcons } from './icons'

const CollapsibleStiffeningBoxSection = ({
  children,
  defaultExpanded = true,
  dataCy,
  isEmpty,
}: CollapsibleBoxSectionProps): ReactElement | null => {
  return (
    <FormCollapsibleSection
      label="Aussteifung"
      startIcon={FormSectionIcons.stiffening}
      defaultExpanded={defaultExpanded}
      dataCy={dataCy}
      isEmpty={isEmpty}
    >
      {children}
    </FormCollapsibleSection>
  )
}

export default CollapsibleStiffeningBoxSection
